import { render, staticRenderFns } from "./PDFDocumentEditor.vue?vue&type=template&id=ccf3344a&scoped=true"
import script from "./PDFDocumentEditor.vue?vue&type=script&lang=js"
export * from "./PDFDocumentEditor.vue?vue&type=script&lang=js"
import style0 from "./PDFDocumentEditor.vue?vue&type=style&index=0&id=ccf3344a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf3344a",
  null
  
)

export default component.exports